type LogContext = Record<string, unknown>

type LogEvent = {
  source: 'window-error' | 'unhandled-rejection'
  message: string
  context?: LogContext
}

const originalConsoleError = console.error.bind(console)
let initialized = false

const capture = (event: LogEvent) => {
  originalConsoleError(`[client-log][${event.source}]`, event.message, event.context ?? {})
}

export const initClientLogging = () => {
  if (initialized) return
  initialized = true

  if (typeof window !== 'undefined') {
    window.addEventListener('error', (ev) => {
      capture({
        source: 'window-error',
        message: ev.message ?? 'Unknown window error',
        context: { filename: ev.filename, lineno: ev.lineno, colno: ev.colno },
      })
    })

    window.addEventListener('unhandledrejection', (ev) => {
      capture({
        source: 'unhandled-rejection',
        message: ev.reason?.message ?? String(ev.reason ?? 'Unknown rejection'),
      })
    })
  }
}
